import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/lib/site";

const links = [
  { id: "outcomes", label: "Outcomes" },
  { id: "framework", label: "Framework" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "voices", label: "Video" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-[hsl(var(--line))]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          data-testid="logo-button"
          aria-label="CDaught Speaks home"
          className="flex items-center"
        >
          <span
            className="block h-10 md:h-11 w-[170px] md:w-[200px]"
            style={{
              backgroundImage: `url(${ASSETS.logo})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "152% auto",
            }}
            role="img"
            aria-label="CDaught Speaks"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}`}
              className="text-[13px] font-medium text-navy/80 hover:text-navy transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => go("contact")}
            data-testid="header-book-btn"
            className="btn-gold hidden sm:inline-flex items-center px-5 py-2.5 text-[13px] font-semibold rounded-sm"
          >
            Book CDaught
          </button>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-btn"
            className="lg:hidden p-2 text-navy"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[hsl(var(--line))]">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`mobile-nav-${l.id}`}
                className="text-left py-2.5 text-[14px] font-medium text-navy/80"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("contact")}
              data-testid="mobile-book-btn"
              className="btn-gold mt-3 py-3 text-[13px] font-semibold rounded-sm"
            >
              Book CDaught
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
